import type { FC, ReactNode } from "react";
import { View } from "react-native";
import { StyleSheet } from "react-native-unistyles";
import { Text } from "@visioni/a3s-ui/components";
import "@visioni/a3s-ui/theme";

export interface ScheduleGroupProps {
  readonly title: string;
  /** `ScheduleRow`s, stacked with a gap. */
  readonly children: ReactNode;
}

/** A titled card holding the report email delivery's rows. */
export const ScheduleGroup: FC<ScheduleGroupProps> = ({ title, children }) => (
  <View role="group" aria-label={title} style={styles.group}>
    <Text textStyle="sm/regular" color="textMuted">
      {title}
    </Text>
    <View style={styles.rows}>{children}</View>
  </View>
);

const styles = StyleSheet.create((theme) => ({
  group: {
    gap: theme.spacing.xl,
    padding: theme.spacing["3xl"],
    borderWidth: 1,
    borderColor: theme.colors.borderCard,
    borderRadius: theme.spacing.md,
    backgroundColor: theme.colors.surfaceCardInner,
  },
  rows: {
    gap: theme.spacing.md,
  },
}));
